import { site } from "./site";

export function localBusinessJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": "CleaningService",
    "@id": `${site.baseUrl}/#business`,
    name: site.name,
    legalName: site.legalName,
    description:
      "Agent d'entretien et société de nettoyage professionnel à Vichy : bureaux, copropriétés, commerces, Airbnb et locations courtes durées, vitres, fin de chantier.",
    url: site.baseUrl,
    telephone: site.phoneHref.replace("tel:", ""),
    email: site.email,
    image: `${site.baseUrl}/og-image.svg`,
    logo: `${site.baseUrl}/logo.png`,
    address: {
      "@type": "PostalAddress",
      postalCode: site.address.postalCode,
      addressLocality: site.address.city,
      addressRegion: site.address.region,
      addressCountry: site.address.country,
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: site.geo.lat,
      longitude: site.geo.lng,
    },
    areaServed: [
      "Vichy",
      "Cusset",
      "Bellerive-sur-Allier",
      "Abrest",
      "Creuzier-le-Vieux",
      "Saint-Yorre",
      "Hauterive",
      "Le Vernet",
      "Allier",
    ].map((n) => ({ "@type": "City", name: n })),
    openingHoursSpecification: [
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        opens: "07:00",
        closes: "19:00",
      },
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: "Saturday",
        opens: "08:00",
        closes: "13:00",
      },
    ],
    foundingDate: String(site.foundingYear),
    sameAs: [site.social.facebook, site.social.instagram, site.social.linkedin],
  };
}

export function websiteJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: site.name,
    url: site.baseUrl,
    inLanguage: "fr-FR",
    potentialAction: {
      "@type": "SearchAction",
      target: `${site.baseUrl}/?s={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  };
}

export function breadcrumbJsonLd(items: { name: string; url: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: it.url,
    })),
  };
}

export function faqJsonLd(faqs: { q: string; a: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map(({ q, a }) => ({
      "@type": "Question",
      name: q,
      acceptedAnswer: { "@type": "Answer", text: a },
    })),
  };
}

export function serviceJsonLd(name: string, description: string, slug: string) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    name,
    description,
    url: `${site.baseUrl}/services/${slug}`,
    provider: { "@id": `${site.baseUrl}/#business` },
    areaServed: { "@type": "City", name: "Vichy" },
  };
}
